import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { LogItem } from "./LogItem";

class LogItemList implements ITableDataSourceItem<LogItem> {
    public Model: LogItem;
    public Name: string;

    constructor(model: LogItem) {
        this.Model = model;
    }
}

export { LogItemList };
